<template>
  <div class="hello">
    <div style="display: flex;flex-direction: column;align-items: center;">
      <NotesTexts></NotesTexts>
      <!-- <div style="font-size: 18px;font-weight: bold;margin-bottom: 10px;">{{ msg }}</div> -->
      <!-- <div style="margin-bottom: 8px;display: flex;width: 100%;" v-if="isAdmin">
        <label style="display: block; margin-bottom: 4px; font-weight: bold; white-space: nowrap;">App Key：</label>
        <el-input v-model="appKey" placeholder="请输入 appKey" style="width: 100%;" clearable />
      </div>
      <div style="margin-bottom: 12px;display: flex;width: 100%;" v-if="isAdmin">
        <label style="display: block; margin-bottom: 4px; font-weight: bold;white-space: nowrap;">App Secret：</label>
        <el-input v-model="appSecret" placeholder="请输入 appSecret" style="width: 100%;" clearable />
      </div> -->
      <div v-if="isAdmin" style="margin-bottom: 10px;display: flex; width: 100%;">
        <label style="display: block; margin-bottom: 4px; font-weight: bold;white-space: nowrap;">推广位ID：</label>
        <el-select v-model="positionId" placeholder="请选择推广位" filterable clearable style="width: 340px;">
          <el-option v-for="p in positions" :key="p.id || p.positionId"
            :label="p.positionName ? `${p.positionId} - ${p.positionName}` : p.positionId" :value="p.positionId" />
        </el-select>
      </div>
      <div style="margin-bottom: 10px;display: flex; align-items: center; width: 100%;">
        <label style="margin-right: 10px;font-weight: bold;white-space: nowrap;">批量转链：</label>
        <el-radio-group v-model="batchFetchGoodsInfo" size="small" class="batch-mode-radio">
          <el-radio-button :label="false">仅转链（快）</el-radio-button>
          <el-radio-button :label="true">仅转链失败再用</el-radio-button>
        </el-radio-group>
      </div>
      <div style="margin-bottom: 12px; width: 100%;">
        <label style="display: block; margin-bottom: 4px; font-weight: bold;">商品链接<i @click="showHelp"
            class="el-icon-info" style="color: #42b983;"></i>：</label>
        <div class="textarea-wrapper">
          <el-input v-model="inputText" type="textarea" placeholder="请输入单个商品链接或粘贴包含多个链接的文本内容,转链的有效期为60天" :rows="5"
            clearable />
          <button v-if="inputText" class="clear-icon" type="button" @click="clearInput" aria-label="清空">×</button>
        </div>
      </div>
      <!-- <button @click="callGoods" style="margin-bottom: 10px;width: 100%;" v-if="isAdmin">调用
        goods.query（非授权）</button> -->
      <div style="display: flex;gap: 10px;width: 100%;">
        <button @click="clearInput"
          style="width: 100%;border: 1px solid #42b983;background: #fff;color: #42b983;">清空</button>
        <button @click="handlePromotion" style="width: 100%;" type="primary" :disabled="!inputText || converting">
          {{ converting ? '转换中...' : '生成推广链接' }}
        </button>
      </div>
      <!-- 单个链接结果展示 -->
      <div v-if="(combinedQrUrl || originalClickUrl) && !batchResult"
        style="margin:10px;text-align:center;width: 100%;">
        <div style="text-align:left; margin: 0 auto 10px;">
          <!-- 完整文案展示 -->
          <div style="margin:6px 0; word-break: break-all; background: #f5f5f5; border-radius: 4px;">
            <strong>转链结果：</strong>
            <div
              style="white-space: pre-wrap; font-family: monospace; margin: 10px 0px;font-size: 14px;border: 1px #42b983 dashed;padding: 10px;border-radius: 4px;">
              <div v-if="isRichGuideText" v-html="guideText"></div>
              <div v-else>{{ guideText }}</div>
              <div>{{ fullContent }}</div>
            </div>
            <div style="margin-top: 10px;display: flex;gap: 10px;">
              <!-- <button @click="handleInvalidReport"
                style="padding: 10px;flex: 1;border: 1px solid #42b983;border-radius: 4px;background: #fff;color: #42b983;">失效上报</button> -->
              <button @click="copyFullContent" style=" padding: 10px;flex: 1;">复制文案</button>
              <button @click="copyText(originalClickUrl)" style="padding: 10px;flex: 1;">复制链接</button>
            </div>
          </div>
        </div>
      </div>

      <!-- 批量转换结果显示 -->
      <div v-if="batchResult"
        style="width: 100%;box-sizing: border-box; margin:10px;text-align:center; border-top: 2px solid #42b983; padding-top: 20px;border: 1px #42b983 dashed;border-radius: 4px;padding: 10px;">
        <div style="text-align:left; margin: 0 auto 10px; max-width: 680px;">
          <div style="margin:6px 0; font-weight: bold; color: #42b983;">
            转换统计: 成功 {{ batchResult.successCount }} 条，失败 {{ batchResult.failCount }} 条
          </div>
          <div
            style="margin:6px 0; word-break: break-all; white-space: pre-wrap; font-family: monospace; background: #f5f5f5; padding: 10px; border-radius: 4px;">
            <div v-html="batchResult.formattedText"></div>
          </div>
          <button @click="copyBatchResult" style="margin-top: 10px; padding: 10px 20px;width: 100%;">复制转换文案</button>
        </div>
      </div>
      <div class="goods-card" v-for="(child, index) in goodsInfo" :key="index">
        <div style="display: flex;min-height: 100px;">
          <!-- 左侧商品图片区域 -->
          <div class="goods-left">
            <img :src="child?.imageInfo?.imageList?.[0]?.url || '/placeholder.png'" :alt="child?.skuName"
              class="goods-image" />
          </div>
          <!-- 右侧商品信息区域 -->
          <div class="goods-right">
            <!-- 商品标题 -->
            <div class="goods-title">
              <span
                style="color: #fff;border-radius: 4px;display: inline-block; margin-bottom: 2px; padding: 2px 4px;background: #42b983;font-size: 10px;">
                {{ child?.shopInfo?.shopName }}</span>
              {{ child?.skuName }}
              <span v-if="child?.key == 'key2'"
                style="color: #fff;border-radius: 4px;padding: 1px 2px;background: #42b983;font-size: 12px;">DIF</span>
            </div>
            <!--佣金信息 -->
            <div class="commission-row">
              <span>预估价：{{ calculateToHandPrice(child).toHandPrice }}</span>
              <span class="commission-value">
                <span style="margin-right: 10px;">💰{{ child?.commissionInfo?.commissionShare }}%</span>
                ￥{{ (calculateToHandPrice(child).toHandPrice * child?.commissionInfo?.commissionShare / 100).toFixed(2)
                  || child?.commissionInfo?.commission.toFixed(2) }}
              </span>
              <!-- <div class="rowBox">
                <span>预估价</span>
                <span>{{ calculateToHandPrice(child).toHandPrice }}</span>
              </div>
              <div class="rowBox">
                <span>比例</span>
                <span>{{ child?.commissionInfo?.commissionShare }}%</span>
              </div>
              <div class="rowBox">
                <span>佣金</span>
                <span>￥{{ (calculateToHandPrice(child).toHandPrice *
                  child?.commissionInfo?.commissionShare /
                  100).toFixed(2) || child?.commissionInfo?.commission.toFixed(2) }}</span>
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <div v-if="(combinedQrUrl || originalClickUrl) && !batchResult" style="width: 100%;">
        <div style="font-weight:bold;margin-bottom:6px;text-align: left;">推广二维码：</div>
        <img :src="combinedQrUrl" alt="二维码生成中..." />
        <div style="margin-top:10px;margin-bottom: 30px;">
          <button @click="downloadCombinedQr" style="padding:10px;width: 100%;">保存图片</button>
        </div>
      </div>
    </div>

    <!-- 帮助图片弹窗 -->
    <el-dialog title="商品链接获取说明" :visible.sync="showHelpDialog" width="90%" :close-on-click-modal="true"
      :close-on-press-escape="true" center>
      <div style="margin-bottom: 10px;">将复制的链接粘贴到输入框中，点击"生成推广链接"按钮，即可生成推广链接</div>
      <div style="text-align: center;">
        <img :src="require('@/assets/images/help.jpg')" alt="帮助说明" style="max-width: 60%; height: 100%;" />
      </div>
      <div style="margin-bottom: 10px;">有其他问题可以参考【我的->获客指南 】 或者咨询 【我的->联系我们】</div>
    </el-dialog>

    <!-- 粘贴内容识别弹窗 -->
    <el-dialog title="识别到剪切版内容" :visible.sync="pasteDialogVisible" width="350px" :close-on-click-modal="false"
      :close-on-press-escape="true" center>
      <div>
        <div style="font-weight: bold; margin-bottom: 8px;">复制版内容：</div>
        <el-input v-model="formattedPasteContent" type="textarea" :rows="15"
          style="font-family: monospace; font-size: 13px;" placeholder="可在此编辑内容" />
      </div>
      <div slot="footer" style="display: flex;gap: 10px;width: 100%;">
        <el-button style="flex: 1;" type="primary" plain @click="handlePasteCancel">取 消</el-button>
        <el-button style="flex: 1;" type="primary" @click="handlePasteConvert" :loading="converting">转 链</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { demoGoodsQueryViaBackend, createPromotionLink, batchCreatePromotionLinks, getCurrentUser, getAllPositions, reportPromotionContentInvalidBySpuid } from '@/utils/jdApi'
import QRCode from 'qrcode'
import { copyToClipboardWithMessage, copyRichTextWithMessage } from '@/utils/clipboard'
export default {
  name: 'PromotionLink',
  components: {
    NotesTexts: () => import('@/components/NotesTexts.vue')
  },
  props: {
    msg: String
  },
  data() {
    return {
      appKey: '',
      appSecret: '',
      // 统一的输入框
      inputText: '',
      // 推广链接生成所需
      currentUser: null,
      positionId: '',
      positions: [],
      batchFetchGoodsInfo: false,
      combinedQrUrl: '',
      originalClickUrl: '',
      // 转换状态和结果
      converting: false,
      batchResult: null,
      fullContent: '', // 完整文案内容
      goodsInfo: [],
      guideText: '',
      // 帮助图片弹窗
      showHelpDialog: false,
      // 粘贴识别弹窗
      pasteDialogVisible: false,
      pasteContent: '',
      formattedPasteContent: '',
      lastClipboardContent: '', // 记录上次读取的剪贴板内容，避免重复处理
      clipboardInterval: null, // 定时器
    }
  },
  computed: {
    isAdmin() {
      return this.currentUser && this.currentUser.role === 'ADMIN'
    },
    isRichGuideText() {
      if (!this.guideText) return false;
      return /<\/?([a-z][a-z0-9]*)\b[^>]*>/i.test(this.guideText);
    }
  },
  mounted() {
    this.currentUser = getCurrentUser()
    if (!this.isAdmin) {
      this.positionId = this.currentUser.positionId
    } else {
      this.loadPositions()
    }
    // 自动读取剪贴板
    // this.autoReadClipboard()
  },
  beforeDestroy() {
    // 清除定时器
    if (this.clipboardInterval) {
      clearInterval(this.clipboardInterval)
    }
  },
  methods: {
    showHelp() {
      this.showHelpDialog = true
    },
    handleInvalidReport() {
      this.$confirm('确认该条信息已经失效、并上报！', '提示', {
        confirmButtonText: '确定',
        confirmButtonClass: 'confirm-dialog-button',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        reportPromotionContentInvalidBySpuid(
          this.goodsInfo.skuName || this.goodsInfo.spuid, // 优先使用 skuName，如果没有则使用 spuid
          this.positionId,
          '推广链接页上报失效'
        ).then(response => {
          if (response && response.success) {
            this.$message({
              type: 'success',
              message: '上报成功!'
            })
          } else {
            this.$message.error('上报失败')
          }
        }).catch(() => {
          this.$message.error('上报失败')
        })
      }).catch(() => {
        // 用户取消
      })

    },
    // 计算到手价
    calculateToHandPrice(goods) {
      // 安全获取价格
      let basePrice = goods.priceInfo?.price
      // 安全国补补贴比例
      const subsidyTag = goods.skuTagList?.find(tag => tag.type === 6 && tag.name.includes('国补'))
      const subsidyRatio = subsidyTag?.name?.match(/(\d+)%/) ? (parseInt(subsidyTag.name.match(/(\d+)%/)[1]) / 100) : 0
      // 计算到手价
      let toHandPrice = basePrice
      let couponDiscountString = ''
      goods.couponInfo?.couponList?.map(coupon => {
        const couponDiscount = coupon.discount || 0
        if (coupon.isBest == 1) {
          if (couponDiscount > 0 && couponDiscount < 1) {
            toHandPrice = (toHandPrice * couponDiscount)
            couponDiscountString += ' * ' + couponDiscount * 10 + '折(券)'
          } else {
            toHandPrice = (toHandPrice - couponDiscount)
            couponDiscountString += ' - ' + couponDiscount + '(券)'
          }
        }
      })
      toHandPrice = (toHandPrice * (1 - subsidyRatio)).toFixed(0)
      // 构建价格显示字符串
      let priceDisplay = toHandPrice + ' = ' + basePrice + ''
      if (couponDiscountString) {
        priceDisplay += couponDiscountString
      }
      // 添加国补信息
      if (subsidyRatio > 0) {
        priceDisplay += ' * ' + (1 - subsidyRatio) * 10 + '折(国补)'
      }
      console.log(priceDisplay, 'priceDisplay');
      return { toHandPrice, priceDisplay }
    },
    clearInput() {
      this.inputText = ''
      this.batchResult = null
      this.combinedQrUrl = ''
      this.originalClickUrl = ''
      this.shortClickUrl = ''
      this.fullContent = ''
      this.goodsInfo = []
    },
    // 自动读取剪贴板内容（页面加载时和定时读取）
    async autoReadClipboard() {
      // 延迟一下，确保页面完全加载
      setTimeout(async () => {
        await this.readClipboard()
      }, 500)

      // 定时读取剪贴板（每2秒检查一次）
      this.clipboardInterval = setInterval(async () => {
        await this.readClipboard()
      }, 2000)
    },
    // 读取剪贴板内容（内部方法）
    async readClipboard() {
      // 如果弹窗已经打开，不重复读取
      if (this.pasteDialogVisible) {
        return
      }
      if (this.inputText && this.inputText.trim()) {
        return
      }
      if (this.converting) {
        return
      }
      try {
        // 检查浏览器是否支持 Clipboard API
        if (!navigator.clipboard || !navigator.clipboard.readText) {
          return
        }
        const clipboardText = await navigator.clipboard.readText()
        if (!clipboardText || !clipboardText.trim()) {
          return
        }
        if (clipboardText.trim() === this.lastClipboardContent) {
          return
        }
        const links = this.extractLinks(clipboardText)
        if (links.length === 0) {
          return
        }
        this.lastClipboardContent = clipboardText.trim()
        this.pasteContent = clipboardText.trim()
        this.formattedPasteContent = clipboardText.trim()
        this.pasteDialogVisible = true
      } catch (error) {
        if (error.name !== 'NotAllowedError') {
          console.debug('读取剪贴板:', error.message)
        }
      }
    },
    // 取消粘贴
    handlePasteCancel() {
      this.pasteDialogVisible = false
      this.pasteContent = ''
      this.formattedPasteContent = ''
    },
    // 处理粘贴转链
    async handlePasteConvert() {
      if (!this.formattedPasteContent || !this.formattedPasteContent.trim()) {
        this.$message?.warning('内容不能为空')
        return
      }
      this.pasteDialogVisible = false
      this.inputText = this.formattedPasteContent.trim()
      this.clearResults()
      await this.handlePromotion()
      // 清空粘贴相关数据
      this.pasteContent = ''
      this.formattedPasteContent = ''
    },

    // 统一的推广链接处理方法
    async handlePromotion() {
      if (!this.inputText) {
        this.$message?.error('请先输入商品链接')
        return
      }
      if (!this.positionId) {
        this.$message?.error('请先选择推广位ID')
        return
      }

      // 清除之前的结果
      this.clearResults()

      // 提取链接
      const links = this.extractLinks(this.inputText)

      if (links.length === 0) {
        this.$message?.error('未找到任何链接')
        return
      }

      // 判断是单个链接还是批量转换
      if (links.length === 1) {
        // 单个链接处理
        await this.handleSingleLink(links[0])
      } else {
        // 批量转换处理
        await this.handleBatchLinks(links)
      }
    },

    // 清除结果数据
    clearResults() {
      this.batchResult = null
      this.combinedQrUrl = ''
      this.originalClickUrl = ''
      this.shortClickUrl = ''
      this.fullContent = ''
      this.guideText = ''
      // 清空商品信息
      this.goodsInfo = []
    },

    // 处理单个链接
    async handleSingleLink(link) {
      this.converting = true
      this.originalClickUrl = ''
      this.shortClickUrl = ''
      this.combinedQrUrl = ''
      this.guideText = ''
      this.batchResult = null

      try {
        const payload = {
          materialId: link,
          positionId: this.positionId
        }

        const res = await createPromotionLink(payload)
        if (res && res.code === 200) {
          // 优先使用后端返回的商品信息（佣金比例高的）
          if (res.goodsInfo) {
            this.goodsInfo = [res.goodsInfo]
            this.guideText = res.goodsInfo.guideText || ''
          } else {
            // 向后兼容：如果没有返回商品信息，尝试查询（但通常不需要）
            this.goodsInfo = null
            this.guideText = ''
          }

          let linkData = null
          if (res.link) {
            // 新格式：link 字段包含转链结果
            linkData = res.link.data || res.link
          } else if (res.data) {
            // 旧格式：直接使用 data 字段
            linkData = res.data
          }

          if (linkData) {
            // 优先使用shortURL，如果没有则使用clickURL
            const click = linkData.shortURL || linkData.clickURL
            if (click) {
              this.originalClickUrl = click

              // 立即生成完整文案（将原链接替换为转换后的链接）
              this.fullContent = this.inputText.replace(link, click)

              // 异步生成二维码（不阻塞完整文案显示）
              this.generateQr(click)
            } else {
              this.$message?.error('未获取到转换链接')
            }
          } else {
            this.$message?.error('转换失败:请输入正确链接')
          }
        } else {
          this.$message?.error('转换失败:请输入正确链接')
        }
      } catch (e) {
        this.$message?.error('请求失败')
      } finally {
        this.converting = false
      }
    },

    // 处理批量链接
    async handleBatchLinks(links) {
      this.converting = true
      this.batchResult = null
      this.goodsInfo = []

      try {
        // 使用新的批量接口
        const materialIds = links.join(',')
        const res = await batchCreatePromotionLinks({
          materialIds: materialIds,
          positionId: this.positionId,
          fetchGoodsInfo: this.batchFetchGoodsInfo
        })

        if (res && res.code === 200 && res.data) {
          // 转换后端返回的格式为前端需要的格式
          // 新格式：每个item是 { code, link }，批量转链不包含商品信息
          const results = res.data.map(item => {
            let linkData = null
            if (item.link) {
              // 新格式：link 字段包含转链结果
              linkData = item.link.data || item.link
            } else if (item.data) {
              // 旧格式：直接使用 data 字段（向后兼容）
              linkData = item.data
            }
            if (item.goodsInfo) {
              const goodsInfo = { ...item.goodsInfo }
              if (item.key) {
                goodsInfo.key = item.key
              }
              this.goodsInfo.push(goodsInfo)
            }
            return {
              originalLink: item.materialId || '',
              convertedLink: (item.code === 200 && linkData) ? (linkData.shortURL || linkData.clickURL) : (item.materialId || ''),
              success: item.code === 200,
              error: item.code !== 200 ? (item.message || '转换失败') : null,
              // 包含所有API返回的完整数据
              fullData: item.code === 200 ? linkData : null,
              shortURL: (item.code === 200 && linkData) ? linkData.shortURL : null,
              clickURL: (item.code === 200 && linkData) ? linkData.clickURL : null,
              jCommand: (item.code === 200 && linkData) ? linkData.jCommand : null,
              jShortCommand: (item.code === 200 && linkData) ? linkData.jShortCommand : null,
              weChatShortLink: (item.code === 200 && linkData) ? linkData.weChatShortLink : null
            }
          })

          // 生成格式化结果
          const formattedText = this.formatResults(this.inputText, results)

          this.batchResult = {
            successCount: res.successCount,
            failCount: res.failCount,
            formattedText: formattedText,
            results: results
          }
        } else {
          this.$message?.error('批量转换失败，请输入正确链接')
        }

      } catch (error) {
        this.$message?.error('批量转换失败，请输入正确链接')
      } finally {
        this.converting = false
      }
    },
    loadPositions() {
      getAllPositions().then(res => {
        if (res && res.success) {
          this.positions = Array.isArray(res.data) ? res.data : []
          this.positionId = this.positions[0].positionId
        }
      }).catch(error => {
        console.error('加载推广位列表异常:', error)
      })
    },
    async callGoods() {
      // 前端不再校验 appKey/appSecret，改为后端代理
      try {
        const res = await demoGoodsQueryViaBackend({ positionId: '3102085776', pageIndex: 1, pageSize: 20, startTime: '2025-09-10 09:03:00', endTime: '2025-09-10 09:59:00' })
        console.log('goods.query', res)
      } catch (e) {
        console.error(e)
      }
    },
    async generateCombinedQr(clickUrl) {
      // 生成二维码 dataURL
      const qrDataUrl = await QRCode.toDataURL(clickUrl, { width: 200, margin: 4 })
      // 创建画布，预留下方文字区域
      const canvas = document.createElement('canvas')
      const qrSize = 200
      const textAreaHeight = 20
      canvas.width = qrSize
      canvas.height = qrSize + textAreaHeight
      const ctx = canvas.getContext('2d')
      // 白底
      ctx.fillStyle = '#fff'
      ctx.fillRect(0, 0, canvas.width, canvas.height)
      // 画二维码
      const img = new Image()
      await new Promise(resolve => {
        img.onload = () => {
          ctx.drawImage(img, 0, 0, qrSize, qrSize)
          resolve()
        }
        img.src = qrDataUrl
      })

      // 在二维码中间添加logo
      const logoImg = new Image()
      await new Promise(resolve => {
        logoImg.onload = () => {
          // 计算logo位置和大小（二维码中心，大小为二维码的1/6，更小避免遮挡）
          const logoSize = qrSize / 6  // 约33px，更小
          const logoX = (qrSize - logoSize) / 2
          const logoY = (qrSize - logoSize) / 2

          // 画白色背景圆形，稍微大一点确保覆盖
          ctx.fillStyle = '#fff'
          ctx.beginPath()
          ctx.arc(qrSize / 2, qrSize / 2, logoSize / 2 + 4, 0, 2 * Math.PI)
          ctx.fill()

          // 画logo
          ctx.drawImage(logoImg, logoX, logoY, logoSize, logoSize)
          resolve()
        }
        logoImg.onerror = () => {
          resolve()
        }
        logoImg.src = require('@/assets/images/qr-logo.png')
      })

      // 画文字（红色、加粗、居中）
      ctx.fillStyle = '#e53935'
      ctx.font = '600 18px Arial'
      ctx.textAlign = 'center'
      ctx.textBaseline = 'middle'
      ctx.fillText('京东扫码', canvas.width / 2, qrSize + textAreaHeight / 2)
      // 输出合成图
      this.combinedQrUrl = canvas.toDataURL('image/png')
    },
    downloadCombinedQr() {
      if (!this.combinedQrUrl) return
      const a = document.createElement('a')
      a.href = this.combinedQrUrl
      a.download = 'jd-qrcode.png'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    copyText(text) {
      if (!text) return
      // 使用公共的复制工具函数
      copyToClipboardWithMessage(text, this, '已复制', '复制失败')
    },


    // 提取文本中的链接
    extractLinks(text) {
      const urlRegex = /https?:\/\/[^\s]+|jingfen\.jd\.com\/[^\s]+/g;
      const commandRegex = /\b[a-zA-Z0-9]{20,36}_[a-zA-Z0-9]{12,20}\b/g;
      const linkMatches = text.match(urlRegex) || []
      const commandMatches = (text.match(commandRegex) || []).filter(cmd => {
        return !linkMatches.some(link => typeof link === 'string' && link.includes(cmd))
      })
      const merged = [...new Set([...linkMatches, ...commandMatches])]
      return merged.map(link => {
        if (typeof link !== 'string') return link
        const trimmed = link.trim()
        if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
          return trimmed
        }
        if (trimmed.startsWith('jingfen.jd.com')) {
          return `https://${trimmed}`
        }
        return trimmed
      })
    },


    // 格式化结果显示
    formatResults(originalText, results) {
      let formattedText = originalText

      // 按链接长度降序排序，避免短链接替换长链接的问题
      const sortedResults = results.sort((a, b) => b.originalLink.length - a.originalLink.length)

      // 替换每个链接
      sortedResults.forEach(result => {
        const originalLink = result.originalLink
        const convertedLink = result.convertedLink

        if (result.success) {
          // 成功转换，使用全局替换
          const regex = new RegExp(originalLink.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g')
          formattedText = formattedText.replace(regex, convertedLink)
        } else {
          // 转换失败，用红色标记，使用全局替换
          const failedLink = `<span style="color: red; background-color: #ffebee; padding: 2px 4px; border-radius: 2px;">${originalLink}</span>`
          const regex = new RegExp(originalLink.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g')
          formattedText = formattedText.replace(regex, failedLink)
        }
      })

      return formattedText
    },

    // 复制批量转换结果
    copyBatchResult() {
      if (!this.batchResult || !this.batchResult.results) return

      // 生成纯文本结果（去除HTML标签）
      let plainText = this.inputText
      this.batchResult.results.forEach(result => {
        if (result.success) {
          // 使用全局替换避免只替换第一个匹配项
          const regex = new RegExp(result.originalLink.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g')
          plainText = plainText.replace(regex, result.convertedLink)
        }
      })

      this.copyText(plainText)
    },

    // 复制完整文案（guideText 和 fullContent 均为纯文本，自动保留换行）
    copyFullContent() {
      const trimQuote = v => (v ? v.replace(/^"+|"+$/g, '').trim() : '');
      const guide = trimQuote(this.guideText);
      const full = trimQuote(this.fullContent);

      if (!guide && !full) return;

      // 构建完整内容：guide + fullContent
      let parts = [];
      if (guide) {
        parts.push(guide);
      }
      if (full) {
        parts.push(full);
      }

      // 如果 guide 是富文本，需要构建 HTML 版本
      let content = parts.join('\n');
      if (this.isRichGuideText && guide) {
        // 如果 guide 是 HTML，构建 HTML 版本
        let htmlContent = '';
        if (guide) {
          htmlContent += guide + '<br>';
        }
        if (full) {
          htmlContent += full.replace(/\n/g, '<br>');
        }
        content = htmlContent;
      }

      // 使用统一的工具函数复制，自动处理换行格式
      copyRichTextWithMessage(content, this, '复制成功', '复制失败，请手动复制');
    },

    // 生成二维码
    async generateQr(clickUrl) {
      try {
        await this.generateCombinedQr(clickUrl)
      } catch (error) {
        console.warn('生成二维码失败:', error)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.hello {
  padding: 20px;
}

h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

button {
  background: #42b983;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
}

.textarea-wrapper {
  position: relative;
  display: inline-block;
  display: flex;
}

.textarea-wrapper textarea {
  padding-right: 32px !important;
}

.clear-icon {
  position: absolute;
  right: 6px;
  top: 6px;
  width: 24px;
  height: 24px;
  line-height: 22px;
  text-align: center;
  border-radius: 50%;
  background: #eee;
  color: #666;
  border: 1px solid #ddd;
  padding: 0;
}

.clear-icon:hover {
  background: #e2e2e2;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .hello {
    padding: 10px;
  }
}

.goods-card {
  background: #fff;
  border: 1px solid #eee;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;

  .goods-image {
    width: 100px;
    height: 100%;
  }

  .goods-right {
    padding: 5px 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .goods-title {
      font-size: 12px;
      font-weight: bold;
      /* line-height: 16px; */
      color: #333;
    }

    .commission-row {
      color: #42b983;
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      font-weight: bold;

      .rowBox {
        display: flex;
        align-items: center;
        flex-direction: column;
      }
    }
  }

}

:deep(.batch-mode-radio .el-radio-button__inner) {
  border-color: #42b983;
  color: #42b983;
  padding: 6px 10px;
}

:deep(.batch-mode-radio .el-radio-button__orig-radio:checked + .el-radio-button__inner) {
  background-color: #42b983;
  border-color: #42b983;
  box-shadow: -1px 0 0 0 #42b983;
  color: #fff;
}

:deep(.el-radio-button:first-child .el-radio-button__inner) {
  border-left: 1px solid #42b983;
}
</style>
